import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }, null, -1)
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1)

import { computed, onMounted, ref } from "vue";
import {
  TeamEffectivenessRatingsApiModel,
  TeamEffectivenessReviewApiModel,
} from "../../api-models";
import Head from "./gyre-head.vue";
import { getTeamEffectivenessReport } from "../team-effectiveness/get-team-effectiveness-report-team-id";


export default /*#__PURE__*/_defineComponent({
  __name: 'team-effectiveness-heads-breakdown',
  props: {
    reviewId: {}
  },
  setup(__props: any) {

const props = __props;

const teamEffectivenessReport = ref<TeamEffectivenessReviewApiModel | null>(null);

const breakdown = computed<{ name: string; rawRatings: TeamEffectivenessRatingsApiModel }[]>(() => {
  const br =
    teamEffectivenessReport.value?.questionnaires.map((r) => ({
      name: `${r.reviewerDetails.firstName} ${r.reviewerDetails.lastName}`,
      rawRatings: r.rawRatings,
    })) ?? [];

  return br;
});

onMounted(() => {
  getTeamEffectivenessReport(props.reviewId).then((data) => {
    teamEffectivenessReport.value = data;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.ceil((breakdown.value || []).length / 2), (i1) => {
      return (_openBlock(), _createElementBlock("div", { key: i1 }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breakdown.value, (result, i2) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (Math.floor(i2 / 2) === i1 - 1)
                ? (_openBlock(), _createElementBlock("div", {
                    class: "col-sm-5",
                    key: i2
                  }, [
                    _createVNode(Head, {
                      values: result.rawRatings.ratings,
                      valueType: "DecimalValue",
                      style: {"width":"50%","margin":"0 auto"},
                      kind: "TeamEffectivenessIndividualDiamond"
                    }, null, 8, ["values"]),
                    _createElementVNode("h5", _hoisted_3, _toDisplayString(result.name), 1),
                    _hoisted_4
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ])
      ]))
    }), 128))
  ]))
}
}

})